module.exports = __webpack_public_path__ + "img/120.10.f0305c3f.png";